import { forwardRef } from 'react';
import { Button, type ButtonProps } from '../actions/Button';

export type ForwardButtonProps = ButtonProps;

/**
 * Primary onboarding CTA with chevron on the right by default.
 */
export const ForwardButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, ForwardButtonProps>(
  function ForwardButton(props, ref) {
    const { icon = 'chevronright', iconPosition = 'right', variant = 'primary', size = 'small', href, ...rest } = props;

    if (typeof href === 'string' && href.length > 0) {
      return <Button ref={ref} {...({ href, variant, size, icon, iconPosition, ...rest } as ButtonProps)} />;
    }

    const { type = 'submit', ...buttonRest } = rest as Extract<ButtonProps, { href?: undefined }>;

    return <Button ref={ref} {...({ type, variant, size, icon, iconPosition, ...buttonRest } as ButtonProps)} />;
  },
);

ForwardButton.displayName = 'ForwardButton';
